import { render, staticRenderFns } from "./ShopSkinView.vue?vue&type=template&id=8f67e288&scoped=true"
import script from "./ShopSkinView.vue?vue&type=script&lang=js"
export * from "./ShopSkinView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f67e288",
  null
  
)

export default component.exports